import { Component } from '@angular/core';
import { OffCanvasChildComponent } from 'src/app/model/off-canvas-child-component';
import { OffCanvasService } from 'src/app/services';

@Component({
    templateUrl: 'info-customer-agreement.component.html',
})
export class InfoCustomerAgreementComponent extends OffCanvasChildComponent
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }
}
